import { IconButton } from '@chakra-ui/react';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

interface DeleteUploadImageIconProps {
  onClickDelete: (event: React.MouseEvent<HTMLButtonElement>) => void;
  setHover: Dispatch<SetStateAction<boolean>>;
  imageBtnOnFocus: Boolean; // only used for tracking if the image button is on focus, when it's on focus, render the delete button for accessibility considerations
}

export const DeleteUploadImageIcon = ({ onClickDelete, setHover, imageBtnOnFocus }: DeleteUploadImageIconProps) => {
  const { t } = useTranslation('editor_widget_menu', { useSuspense: false });
  const handleMouseEnter = () => setHover(true);
  const handleMouseLeave = () => setHover(false);

  return (
    <IconButton
      display={imageBtnOnFocus ? 'flex' : 'none'}
      backgroundColor='blackAlpha.700'
      _groupHover={{ display: 'flex' }}
      _focus={{ display: 'flex' }}
      _hover={{ bgColor: 'font.500' }}
      position='absolute'
      top='0'
      right='0'
      size='sm'
      aria-label={t('sideBar.widget_menu_upload.deleteUploadedImageLabel')}
      onClick={onClickDelete}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      icon={<DeleteIcon color='white' />}
      data-testid='delete-image-upload-icon'
    />
  );
};
